export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

export const validatePassword = (password) => {
  return {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    isValid: password.length >= 8 && /[A-Z]/.test(password) && /\d/.test(password),
  }
}

export const passwordsMatch = (password, confirmPassword) => {
  return password === confirmPassword
}
